<div class="donut-chart">
  <div #chartContainer class="{{chartClass}}">
    <svg #donutSvg id="donut-chart" [attr.width]="width" [attr.height]="height">
      <defs id="chart-gradients">
        <linearGradient id="gradient-gray">
          <stop offset="0%" stop-color="#878787" />
          <stop offset="100%" stop-color="#878787" />
        </linearGradient>
        <linearGradient *ngFor="let item of chartData; let i = index" id="gradient-{{item.id}}">
          <stop offset="0%" [attr.stop-color]="item.color1" />
          <stop offset="100%" [attr.stop-color]="item.color2" />
        </linearGradient>

        <linearGradient id="gradient-ring" x1="0%" y1="00%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="rgb(200,200,255)" stop-opacity="1" />
          <stop offset="30%" stop-color="rgb(50,50,255)" stop-opacity="0.2" />
          <stop offset="70%" stop-color="rgb(50,50,255)" stop-opacity="0.2" />
          <stop offset="100%" stop-color="rgb(200,200,255)" stop-opacity="1" />
        </linearGradient>
        <filter id="shadow">
          <feDropShadow flood-color="#ffffff" dx="0" dy="0" stdDeviation="4" />
        </filter>
      </defs>
    </svg>
  </div>
  <div id="pie-values" class="{{ legendClass }}" #chartLegends>
    <div class="donut-chart__item" *ngFor="let item of chartData; let i = index" (click)="selectItem(item)"
      [style.color]="(selected && selected.id !== item.id) ? '#878787' : 'white'">
      <span [style.color]="_options?.legendFontColor">{{ item.name }}</span>
      <div class="donut-chart__number" [style.color]="_options?.dividerColor">
        <span [style.color]="_options?.legendFontColor">{{ item.value ? item.value : 0 }}</span>
      </div>
      <div class="donut-chart__bar" [style.background-color]="_options?.legendBackgroundColor">
        <div class="donut-chart__color" style="height:100%;"
          [style.background-image]="(selected && selected.id !== item.id) ? 'linear-gradient(to right,#878787,#878787)' : 'linear-gradient(to right,'+item.color1 + ',' +item.color2+ ')'"
          [style.width]="((total && item.value) ? item.value/total*100 : 0) + '%'">
        </div>
      </div>
    </div>
  </div>
</div>
